@if (noImage()) {
  <div
    (click)="input.click()"
    class="flex flex-col justify-center items-center min-h-20 h-full w-full cursor-pointer border border-proffeo-border rounded-lg bg-proffeo-surface"
  >
    <mat-icon
      fontIcon="photo_camera"
      class="icon-disabled"
    />
    <div class="text-proffeo-muted">
      {{ 'company-projects.modals.add-image' | translate }}
    </div>
  </div>
} @else {
  <proffeo-project-avatar
    (click)="input.click()"
    [url]="avatarUrl()"
    [projectName]="projectName()"
    size="large"
    class="cursor-pointer flex w-full h-full justify-center items-center"
  ></proffeo-project-avatar>
}

<input
  #input
  (change)="onFileSelected(input)"
  type="file"
  hidden
  accept="image/*"
/>
